import { themeVars } from '@coverflex-tech/hypernova';
import { globalStyle, style } from '@vanilla-extract/css';

const form = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.lg,
  margin: `${themeVars.spacing.lg} 0`,
});

const fields = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.md,
});

const button = style({
  alignSelf: 'flex-start',
});

const hintInvalid = style({
  color: themeVars.color.semantic.text.systemError,
});

const hintValid = style({
  color: themeVars.color.semantic.text.systemSuccess,
});

const disclaimer = style({});

globalStyle(`${disclaimer} a`, {
  fontWeight: 'bold',
  textDecoration: 'underline',
});

export const css = { form, fields, button, hintInvalid, hintValid, disclaimer };
